export type Lang = 'zh-CN' | 'en' | 'zh-TW'
export type Theme = 'light' | 'dark'

const translations: Record<Lang, Record<string, string>> = {
  'zh-CN': {
    // Nav
    'nav.import': '导入',
    'nav.timeline': '时间线',
    'nav.edit': '剪辑',
    'nav.export': '导出',
    // Topbar
    'topbar.system': 'SYSTEM ONLINE',
    'topbar.mode.car': 'CAR_MODE',
    'topbar.mode.web': 'WEB_MODE',
    // Import
    'import.title': '导入管理',
    'import.drop': '拖拽视频文件到这里',
    'import.drop-desc': '支持 MP4 / MOV / M4V / TS 格式',
    'import.open-folder': '打开文件夹',
    'import.select-files': '选择文件',
    'import.imported': '已导入',
    'import.skipped': '跳过',
    'import.duplicates': '重复',
    'import.recent': '最近导入',
    'import.clear': '清空列表',
    // Timeline
    'timeline.dates': '日期',
    'timeline.no-video': '暂无视频',
    // Edit
    'edit.crop': '裁剪',
    'edit.merge': '拼接',
    'edit.rotate': '旋转',
    'edit.preview': '视频预览',
    'edit.source': '源文件',
    'edit.select-video': '选择视频',
    'edit.trim': '裁剪区间',
    'edit.start': '开始',
    'edit.end': '结束',
    'edit.duration': '片段时长',
    'edit.watermark': '水印',
    'edit.watermark-text': '文字',
    'edit.watermark-size': '字号',
    'edit.watermark-color': '颜色',
    'edit.watermark-pos': '位置',
    'edit.output': '输出设置',
    'edit.filename': '文件名',
    'edit.format': '格式',
    'edit.resolution': '分辨率',
    'edit.export': '导出视频',
    'edit.exporting': '导出中...',
    'edit.placeholder': '占位符：{date} {time} {datetime}',
    'edit.tip-drag': '拖拽红点调整裁剪区间',
    'edit.tip-range': '拖拽中间区域整体移动',
    'edit.tip-seek': '点击时间轴快速定位',
    // Export
    'export.title': '导出分享',
    'export.refresh': '刷新',
    'export.processing': '处理中',
    'export.completed': '已完成',
    'export.pending': '待处理',
    'export.failed': '失败',
    'export.download': '下载',
    'export.save-usb': '保存到U盘',
    'export.bluetooth': '蓝牙传输',
    'export.no-tasks': '暂无导出任务',
    'export.create-first': '请先在剪辑页创建导出',
    // Generic
    'generic.mbps': 'MB',
    'generic.min': '分',
    'generic.sec': '秒',
    'generic.fps': 'fps',
    'generic.original': '原画',
    // Tips
    'tips.watermark': '水印将叠加在视频右下角',
    'tips.usb': '请先插入U盘再执行导出',
    'tips.bt': '确保手机蓝牙已开启并配对',
  },
  'en': {
    'nav.import': 'IMPORT',
    'nav.timeline': 'TIMELINE',
    'nav.edit': 'EDIT',
    'nav.export': 'EXPORT',
    'topbar.system': 'SYSTEM ONLINE',
    'topbar.mode.car': 'CAR_MODE',
    'topbar.mode.web': 'WEB_MODE',
    'import.title': 'Import Management',
    'import.drop': 'Drop video files here',
    'import.drop-desc': 'Supports MP4 / MOV / M4V / TS formats',
    'import.open-folder': 'Open Folder',
    'import.select-files': 'Select Files',
    'import.imported': 'Imported',
    'import.skipped': 'Skipped',
    'import.duplicates': 'Duplicates',
    'import.recent': 'Recent Imports',
    'import.clear': 'CLEAR',
    'timeline.dates': 'DATES',
    'timeline.no-video': 'NO RECORDINGS',
    'edit.crop': 'CROP',
    'edit.merge': 'MERGE',
    'edit.rotate': 'ROTATE',
    'edit.preview': 'PREVIEW',
    'edit.source': 'SOURCE',
    'edit.select-video': 'SELECT VIDEO',
    'edit.trim': 'TRIM RANGE',
    'edit.start': 'START',
    'edit.end': 'END',
    'edit.duration': 'DURATION',
    'edit.watermark': 'WATERMARK',
    'edit.watermark-text': 'TEXT',
    'edit.watermark-size': 'SIZE',
    'edit.watermark-color': 'COLOR',
    'edit.watermark-pos': 'POSITION',
    'edit.output': 'OUTPUT',
    'edit.filename': 'FILENAME',
    'edit.format': 'FORMAT',
    'edit.resolution': 'RESOLUTION',
    'edit.export': 'EXPORT VIDEO',
    'edit.exporting': 'EXPORTING...',
    'edit.placeholder': 'Placeholders: {date} {time} {datetime}',
    'edit.tip-drag': 'Drag handles to set trim range',
    'edit.tip-range': 'Drag center to move range',
    'edit.tip-seek': 'Click timeline to seek',
    'export.title': 'Export Queue',
    'export.refresh': 'REFRESH',
    'export.processing': 'PROCESSING',
    'export.completed': 'COMPLETE',
    'export.pending': 'PENDING',
    'export.failed': 'FAILED',
    'export.download': 'DOWNLOAD',
    'export.save-usb': 'SAVE TO USB',
    'export.bluetooth': 'BLUETOOTH',
    'export.no-tasks': 'NO TASKS',
    'export.create-first': 'CREATE IN EDIT PAGE',
    'generic.mbps': 'MB',
    'generic.min': 'min',
    'generic.sec': 'sec',
    'generic.fps': 'fps',
    'generic.original': 'ORIGINAL',
    'tips.watermark': 'Watermark overlays bottom-right',
    'tips.usb': 'Insert USB before exporting',
    'tips.bt': 'Ensure phone Bluetooth is on',
  },
  'zh-TW': {
    'nav.import': '匯入',
    'nav.timeline': '時間線',
    'nav.edit': '剪輯',
    'nav.export': '匯出',
    'topbar.system': '系統運作中',
    'topbar.mode.car': '車機模式',
    'topbar.mode.web': '網頁模式',
    'import.title': '匯入管理',
    'import.drop': '拖曳影片至此',
    'import.drop-desc': '支援 MP4 / MOV / M4V / TS 格式',
    'import.open-folder': '開啟資料夾',
    'import.select-files': '選擇檔案',
    'import.imported': '已匯入',
    'import.skipped': '跳過',
    'import.duplicates': '重複',
    'import.recent': '最近匯入',
    'import.clear': '清除',
    'timeline.dates': '日期',
    'timeline.no-video': '暫無影片',
    'edit.crop': '裁剪',
    'edit.merge': '拼接',
    'edit.rotate': '旋轉',
    'edit.preview': '影片預覽',
    'edit.source': '來源',
    'edit.select-video': '選擇影片',
    'edit.trim': '裁剪區間',
    'edit.start': '開始',
    'edit.end': '結束',
    'edit.duration': '片段時長',
    'edit.watermark': '浮水印',
    'edit.watermark-text': '文字',
    'edit.watermark-size': '字號',
    'edit.watermark-color': '顏色',
    'edit.watermark-pos': '位置',
    'edit.output': '輸出設定',
    'edit.filename': '檔名',
    'edit.format': '格式',
    'edit.resolution': '解析度',
    'edit.export': '匯出影片',
    'edit.exporting': '匯出中...',
    'edit.placeholder': '佔位符：{date} {time} {datetime}',
    'edit.tip-drag': '拖曳紅點調整裁剪區間',
    'edit.tip-range': '拖曳中間區域整體移動',
    'edit.tip-seek': '點擊時間軸快速定位',
    'export.title': '匯出佇列',
    'export.refresh': '重新整理',
    'export.processing': '處理中',
    'export.completed': '已完成',
    'export.pending': '待處理',
    'export.failed': '失敗',
    'export.download': '下載',
    'export.save-usb': '儲存至USB',
    'export.bluetooth': '藍牙傳輸',
    'export.no-tasks': '暫無匯出任務',
    'export.create-first': '請先在剪輯頁建立匯出',
    'generic.mbps': 'MB',
    'generic.min': '分',
    'generic.sec': '秒',
    'generic.fps': 'fps',
    'generic.original': '原畫',
    'tips.watermark': '浮水印將疊加在影片右下角',
    'tips.usb': '請先插入USB再執行匯出',
    'tips.bt': '確保手機藍牙已開啟並配對',
  },
}

let currentLang: Lang = ('zh-CN' as Lang)
let currentTheme: Theme = 'light'

export function setLang(lang: Lang) { currentLang = lang; localStorage.setItem('teslacam_lang', lang) }
export function setTheme(theme: Theme) { currentTheme = theme; localStorage.setItem('teslacam_theme', theme); applyTheme(theme) }

export function t(key: string): string {
  return translations[currentLang]?.[key] ?? translations['zh-CN']?.[key] ?? key
}

function applyTheme(theme: Theme) {
  document.body.classList.toggle('dark', theme === 'dark')
  document.body.style.backgroundColor = theme === 'dark' ? '#0A0A0A' : '#FAFAFA'
  document.body.style.color = theme === 'dark' ? '#FAFAFA' : '#0A0A0A'
}

export function initI18n() {
  const savedLang = localStorage.getItem('teslacam_lang') as Lang | null
  if (savedLang && translations[savedLang]) currentLang = savedLang
  const savedTheme = localStorage.getItem('teslacam_theme') as Theme | null
  if (savedTheme) currentTheme = savedTheme
  applyTheme(currentTheme)
}

export { currentLang, currentTheme, translations }
